// TODO: Reitroduce CosmosActionMenu and CosmosActionMenuItem once Cosmos fixes the issues with GSAP.
import { isExternalLink } from "../../helpers/isExternalLink";
import { ButtonPcs } from "../ButtonPcs/ButtonPcs";
import {
  // CosmosActionMenu,
  // CosmosActionMenuItem,
  CosmosButtonProps,
  CosmosIconAmazon,
  CosmosIconChevronDown,
  CosmosIconGlobeGeo,
  CosmosIconShop,
  CosmosText,
} from "@cosmos/web-react";
import classNames from "classnames";
import classNamesBind from "classnames/bind";
import { ComponentProps, useId, useState } from "react";
import styles from "./SelectButton.module.css";

const cx = classNamesBind.bind(styles);

// We want these icons as an array to use elsewhere, and make it a Type.
const iconTypes = ["amazon", "shop", "globe"] as const;
type SelectButtonIconType = (typeof iconTypes)[number];

export interface items {
  url: string;
  icon?: SelectButtonIconType;
  label: string;
  onClick?: () => void;
}

export const SelectButton = ({
  buttonClassName,
  disabled,
  buttonKind = "primary",
  buttonSize = "medium",
  buttonAppearance = "dark",
  label,
  items,
  buttonCustomColor,
  listboxPosition = "below",
}: {
  buttonClassName?: string;
  disabled?: boolean;
  buttonKind?: CosmosButtonProps["kind"];
  buttonSize: CosmosButtonProps["size"];
  buttonAppearance?: CosmosButtonProps["appearance"];
  label: string; // Label is only used when there are more than 1 vendor links
  items: items[];
  buttonCustomColor?: ComponentProps<typeof ButtonPcs>["customColor"];
  listboxPosition?: "above" | "below";
}) => {
  const id = useId();

  // These can be removed once Cosmos ActionMenu fixes the issues.
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const onClick = () => setIsExpanded((current) => !current);
  // END remove the above code once Cosmos fix is done

  // If any items have an icon, we want to add a spacer in front of items without an icon for visual alignment.
  const anyItemHasIcon = items.some(
    (item) =>
      item.icon !== null &&
      item.icon !== undefined &&
      iconTypes.includes(item.icon),
  );

  return (
    <>
      {items.length === 1 ? (
        <>
          {items.map((item, index) => (
            <ButtonPcs
              key={index}
              className={classNames(buttonClassName)}
              href={item.url}
              target={isExternalLink(item.url ?? "") ? "_blank" : undefined}
              icon-placement="before"
              kind={buttonKind}
              onClick={item.onClick}
              size={buttonSize}
              appearance={buttonAppearance}
              customColor={buttonCustomColor}
            >
              {item.icon === "amazon" ? (
                <CosmosIconAmazon slot="icon" aria-hidden="true" />
              ) : item.icon === "shop" ? (
                <CosmosIconShop slot="icon" aria-hidden="true" />
              ) : item.icon === "globe" ? (
                <CosmosIconGlobeGeo slot="icon" aria-hidden="true" />
              ) : undefined}
              {item.label}
            </ButtonPcs>
          ))}
        </>
      ) : (
        <div className={cx("container")}>
          <ButtonPcs
            className={classNames(buttonClassName, cx("button"))}
            shape="pill"
            size={buttonSize}
            appearance={buttonAppearance}
            icon-placement="after"
            disabled={disabled}
            kind={buttonKind}
            type="button" // prevent accidental form submits
            id={id}
            customColor={buttonCustomColor}
            // Remove below once Cosmos fix is done
            onClick={onClick} // remove once Cosmos fix is done
            aria-haspopup="listbox" // remove once Cosmos fix is done
            aria-expanded={isExpanded ? "true" : "false"} // remove once Cosmos fix is done
            aria-controls={`${id}-button-select`} // remove once Cosmos fix is done
            onBlur={(event) => {
              if (event.relatedTarget === null && isExpanded) {
                setIsExpanded(false);
              }
            }} // remove once Cosmos fix is done
          >
            <CosmosIconChevronDown
              aria-hidden="true"
              className={cx("icon")}
              slot="icon"
            />
            {label}
          </ButtonPcs>
          <div
            hidden={!isExpanded}
            id={`${id}-button-select`}
            role="listbox"
            className={cx("listbox")}
            data-open={isExpanded}
            data-position={listboxPosition}
          >
            {items.map((item, index) => (
              <a
                key={index}
                className={cx("listbox__option")}
                href={item.url}
                target={isExternalLink(item.url ?? "") ? "_blank" : undefined}
                onClick={item.onClick}
              >
                <div className={cx("listbox__option-content")}>
                  {item.icon === "amazon" ? (
                    <CosmosIconAmazon
                      aria-hidden="true"
                      className={cx("listbox__option-prefix")}
                      slot="icon"
                    />
                  ) : item.icon === "shop" ? (
                    <CosmosIconShop
                      aria-hidden="true"
                      className={cx("listbox__option-prefix")}
                      slot="icon"
                    />
                  ) : item.icon === "globe" ? (
                    <CosmosIconGlobeGeo
                      aria-hidden="true"
                      className={cx("listbox__option-prefix")}
                      slot="icon"
                    />
                  ) : anyItemHasIcon ? (
                    <span
                      slot="icon"
                      className={cx("icon-spacer")}
                      aria-hidden="true"
                    />
                  ) : undefined}
                  <CosmosText
                    className={cx("listbox__option-label")}
                    size="small"
                    clamp={1}
                  >
                    {item.label}
                  </CosmosText>
                  {/* <CosmosIconExternalLink
                    className={cx("listbox__option-suffix")}
                  /> */}
                </div>
              </a>
            ))}
          </div>
          {/* 
          <CosmosActionMenu trigger={id} placement={listboxPosition}> 
            {items.map((item, index) => (
              <CosmosActionMenuItem
                key={index}
                href={item.url}
                target={isExternalLink(item.url ?? "") ? "_blank" : undefined}
                onClick={item.onClick}
              >
                {item.icon === "amazon" ? (
                  <CosmosIconAmazon aria-hidden="true" slot="prefix" />
                ) : item.icon === "shop" ? (
                  <CosmosIconShop aria-hidden="true" slot="prefix" />
                ) : item.icon === "globe" ? (
                  <CosmosIconGlobeGeo aria-hidden="true" slot="prefix" />
                ) : anyItemHasIcon ? (
                  <span
                    slot="prefix"
                    className={cx("icon-spacer")}
                    aria-hidden="true"
                  />
                ) : undefined}
                {item.label}
              </CosmosActionMenuItem>
            ))}
          </CosmosActionMenu>
          */}
        </div>
      )}
    </>
  );
};
